var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 513 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8081",
    fillRule: "nonzero",
    d: "M0 25.536v-4.438L13.886 4.629H.277V0h19.99v4.438L6.345 20.925h13.609v4.611H0z",
    transform: "translate(-1675.49 -237.349) scale(4.16667) translate(402.118 57.622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8081",
    fillRule: "nonzero",
    d: "M0 25.536V0h18.549v4.438H5.184v5.444h12.219v4.369H5.184v6.57h13.99v4.715H0z",
    transform: "translate(-1675.49 -237.349) scale(4.16667) translate(426.73 57.622)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8081",
    fillRule: "nonzero",
    d: "M0 25.536V0h5.495l10.367 17.544V0h5.184v25.536h-5.427L5.184 7.992v17.544H0z",
    transform: "translate(-1675.49 -237.349) scale(4.16667) translate(451.187 57.622)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8081",
    fillRule: "nonzero",
    d: "M0 25.536V4.559h-7.576V0h20.353v4.559H5.253v20.977H0z",
    transform: "translate(-1675.49 -237.349) scale(4.16667) translate(484.068 57.622)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8081",
    fillRule: "nonzero",
    d: "M0-.001c0 2.809.624 4.99 1.872 6.544C3.12 8.098 4.865 8.875 7.107 8.875c2.266 0 4.028-.777 5.289-2.332 1.258-1.554 1.889-3.735 1.889-6.544 0-2.808-.631-4.989-1.889-6.544C11.135-8.1 9.373-8.877 7.107-8.877c-2.242 0-3.987.774-5.235 2.323C.624-5.004 0-2.82 0-.001m-5.356 0c0-4.125 1.124-7.399 3.371-9.821 2.248-2.42 5.279-3.631 9.092-3.631 3.814 0 6.851 1.213 9.111 3.64 2.26 2.427 3.389 5.698 3.389 9.812 0 4.115-1.129 7.385-3.389 9.813-2.26 2.427-5.297 3.64-9.111 3.64-3.813 0-6.844-1.213-9.092-3.64-2.247-2.428-3.371-5.698-3.371-9.813",
    transform: "translate(-1675.49 -237.349) scale(4.16667) translate(505.405 70.417)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCons);
export default __webpack_public_path__ + "static/media/logoCons.4b6d4842ff42da404768b2667585adb5.svg";
export { ForwardRef as ReactComponent };